import { render, staticRenderFns } from "./HisTaskDealModal.vue?vue&type=template&id=447f3078&scoped=true&"
import script from "./HisTaskDealModal.vue?vue&type=script&lang=js&"
export * from "./HisTaskDealModal.vue?vue&type=script&lang=js&"
import style0 from "./HisTaskDealModal.vue?vue&type=style&index=0&id=447f3078&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447f3078",
  null
  
)

export default component.exports